// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-dialog-content {
  min-width: 750px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
  justify-content: flex-end;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

.loader-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
}

.small-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.input-group .btn {
  padding: 0.25rem 0.5rem;
}

.remove-icon {
  cursor: pointer;
  color: #dc3545;
  font-size: 20px;
}

.remove-icon:hover {
  color: #bb2d3b;
}

.default-ratios-link {
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.85rem;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/add-test-dialog/add-test-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["mat-dialog-content {\n  min-width: 750px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n  justify-content: flex-end;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\n.loader-overlay {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 150px;\n}\n\n.small-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n}\n\n.input-group .btn {\n  padding: 0.25rem 0.5rem;\n}\n\n.remove-icon {\n  cursor: pointer;\n  color: #dc3545;\n  font-size: 20px;\n}\n\n.remove-icon:hover {\n  color: #bb2d3b;\n}\n\n.default-ratios-link {\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
